import { createStore, combineReducers } from 'redux'
import { RoleUserReducer } from './reducers/RoleUserReducer';
import { LoadingReducer } from './reducers/LoadingReducer';
import { EnderecoReducer } from './reducers/EnderecoReducer';
import { LoginReducer } from './reducers/LoginReducer';
import { AlertDialogReducer } from './reducers/AlertDialogReducer';
import { AtivarContaReducer } from './reducers/AtivarContaReducer';
import { ResetarSenhaReducer } from './reducers/ResetarSenhaReducer';
import { UserReducer } from './reducers/UserReducer';
import { ContatoReducer } from './reducers/ContatoReducer';
import { CidadesReducer } from './reducers/CidadesReducer';
import { OpportunityReducer } from './reducers/OpportunityReducer';
import { ProfessionalProfileReducer } from './reducers/ProfessionalProfile';
import { FotoPerfilReducer } from './reducers/FotoPerfilReducer';

const rootReducer = combineReducers({
    role: RoleUserReducer,
    loading: LoadingReducer,
    endereco: EnderecoReducer,
    login: LoginReducer,
    alertDialog: AlertDialogReducer,
    ativarConta: AtivarContaReducer,
    resetSenha: ResetarSenhaReducer,
    user: UserReducer,
    contato: ContatoReducer,
    cidades: CidadesReducer,
    opportunity: OpportunityReducer,
    professionalProfile: ProfessionalProfileReducer,
    fotoPerfil: FotoPerfilReducer,
})

const store = createStore(rootReducer);

export default store;